import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Layout } from 'blaze-validator';
import { connect } from 'react-redux';
import toastr from '../toastr';
import { modal } from '../modal/ModalEmitter';
import Socket from '../../services/SocketService';
import layouts from './layouts';
import Form from '../form/Form';
import ApiService from '../../services/ApiService';
import PageService from '../../services/PageService';
import '../../styles/timecard.scss';

const itemName = 'TIMECLOCK';

const TimeCard = ({ user }) => {
  const [showCard, setShowCard] = useState(false);
  const [cardLayout, setCardLayout] = useState(layouts.second);
  const [key, setKey] = useState(1);
  const [firstPayload, setFirstPayload] = useState([]);
  const [locked, setLocked] = useState(false);
  const [lockItem, setLockItem] = useState('');

  const { branch } = user;
  const lockId = `${branch.mvAccount}-${itemName}-${lockItem}`;

  const forceUnlockIssued = lockedBy => {
    modal.info({
      message: `Force unlocked was issued by ${lockedBy.firstName} ${lockedBy.lastName}.`,
      title: 'Notice',
      size: 'sm',
    });
  };

  const showLockedDialog = (lockedBy) => {
    const useItem = lockItem;
    modal.open('pageLocked', {
      callback: () => {
        PageService.unlockPage(itemName, useItem);
        PageService.lockPage(itemName, useItem);
        setLocked(false);
        setShowCard(true);
        setLockItem(useItem);
      },
      lockedBy,
    });
  };

  const getLockStatus = () => {
    return new Promise(resolve => {
      PageService.getLock(itemName, lockItem).then(response => {
        const lockedBy = response.data.user;
        const isMe = lockedBy ? lockedBy.username === user.username : false;
        const isLocked = lockedBy !== null && !isMe;
        resolve({ isLocked, lockedBy, isMe });
      });
    });
  };

  const removeMyLock = () => {
    if (!lockItem) {
      return;
    }

    Socket.global.off(`${lockId}.lock`);

    getLockStatus().then(({ isMe }) => {
      if (isMe) {
        PageService.unlockPage(itemName, lockItem);
      }
    });
  };

  const handleSelectTech = payload => {
    setFirstPayload(payload.map(i => i));
    const newEditDate = payload[1].data;
    const newEditName = payload[0].data;
    const newLockItem = `${newEditName}-${newEditDate}`;

    payload.push({ collection: false, name: 'currentStep', data: 1, final: false });
    return ApiService.put('/item/STP6', payload).then(response => {
      const { data } = response;
      setLockItem(newLockItem);
      setCardLayout(new Layout(layouts.second).populateLayout(data).getLayout());
    });
  };

  const handleTimeEdit = edits => {
    edits.push({ collection: false, name: 'currentStep', data: 2, final: true });
    const payload = [...firstPayload, ...edits];
    return ApiService.put('/item/STP6', payload).then(() => {
      toastr.success(`Updated Time Card (${lockItem})`);
      setShowCard(false);
    });
  };

  const handleCancel = () => {
    setShowCard(false);
  };

  useEffect(() => {
    setKey(key + 1);
  }, [cardLayout]);

  useEffect(() => {
    if (lockItem) {
      if (!showCard) {
        getLockStatus().then(({ isLocked, lockedBy }) => {
          setLocked(isLocked);

          if (isLocked) {
            showLockedDialog(lockedBy);
            setLockItem('');
          } else {
            PageService.lockPage(itemName, lockItem);
            setShowCard(true);
          }
        });
      }
    }
  }, [lockItem]);

  useEffect(() => {
    if (showCard === false) {
      removeMyLock();
      setFirstPayload([]);
      setLockItem('');
    } else {
      Socket.global.on(`${lockId}.lock`, (lockedBy = {}) => {
        if (!locked && user.id !== lockedBy.id) {
          setShowCard(false);
          setLocked(true);
          forceUnlockIssued(lockedBy);
        }
      });
    }
  }, [showCard]);

  useEffect(() => {
    return () => {
      removeMyLock();
    };
  }, []);

  return (
    <div className="time-card">
      {!showCard && (
        <div className="select-tech">
          <Form layout={layouts.first} submit={handleSelectTech} submitAll hideCancel feedback="none" />
        </div>
      )}
      {showCard && (
        <div className="edit-card">
          {/* <div className="edit-name">
            Technician {lockItem}
          </div> */}
          <Form
            key={key}
            itemName="STP6"
            layout={cardLayout}
            onCancel={handleCancel}
            readOnly={locked}
            submit={handleTimeEdit}
            submitAll
            legacyFormat
          />
        </div>
      )}
    </div>
  );
};

TimeCard.propTypes = {
  user: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    user: state.app.user,
  };
}

export default connect(mapStateToProps)(TimeCard);
